// extracted by mini-css-extract-plugin
export var actionText = "_hr-4";
export var container = "_hr-0";
export var leftSection = "_hr-1";
export var rightSection = "_hr-2";
export var settingsButton = "_hr-6";
export var settingsIcon = "_hr-7";
export var shortcut = "_hr-5";
export var shortcutGroup = "_hr-3";